define(function (require) {

    var _ = require('underscore');
    var BaseConnectionsListTableViewController = require('web-agent-viewControllers/BaseConnectionsListTableViewController');
    var MyConnectionsListWidgetsManager = require('web-agent-viewControllers/MyConnectionsListWidgetsManager');
    var MyConnectionsEngagementWidget = require('web-agent-widgets/MyConnectionsEngagementWidget');
    var ConsumerInfoWidget = require('web-agent-widgets/ConsumerInfoWidget');

    var MyConnectionsListTableViewController = BaseConnectionsListTableViewController.extend({
        ControllerName: "MyConnectionsListTableViewController",
        applicationType: "MyConnectionsListTableViewController",

        initialize: function (constructorData) {
        },

        events: function () {
        },

        render: function () {
        }
    });

    MyConnectionsListTableViewController.prototype.getConfiguration = function () {
        var configuration = {
            context: this,
            textsPrefix: this.LPPrefixMap.myConnectionsList,
            tableName: this.applicationType,
            tableRootModelPath: "connectionsList",
            globalData: {
                tableName: this.applicationType,
                textsPrefix: this.LPPrefixMap.myConnectionsList
            },
            paging: {
                pageSize: this.getModelControllerInstance().getDefaultValue("limit"),
                hidePagingText: true
            },
            widgets: {
                widgetsManager: MyConnectionsListWidgetsManager,
                widgetsManagerData: {
                    className: "my_connections_widgets",
                    autoHideButtonsToolbar: false,
                    itemIdTag: "convId",
                    widgetsData: [
                        {
                            widgetType: MyConnectionsEngagementWidget,
                            widgetData: {
                                itemIdTag: "convId",
                                chatsRootModelPath: 'chats'
                            }
                        },
                        {
                            widgetType: ConsumerInfoWidget,
                            widgetData: {
                                visitorInfoPath: "consumerProfile",
                                chatIdPath: "convId"

                            }
                        }
                    ]
                }
            }
        };
        return configuration;
    };

    MyConnectionsListTableViewController.prototype.getModelControllerInstance = function () {
      return lpTag.WebAgent.myConnectionListController;
    };

    MyConnectionsListTableViewController.prototype.getColumnsData = function () {
        var columnsData = BaseConnectionsListTableViewController.prototype.getColumnsData.call(this);
        var lastMessageColumnIndex = _.findIndex(columnsData, {title: 'LAST_MESSAGE_TIME'} + 1);
        columnsData.splice(lastMessageColumnIndex, 0,  {title: "LAST_MESSAGE"});
        var slaIndex = _.findIndex(columnsData, {dataPersonalization: "SLA"});
        columnsData[slaIndex].dataPersonalization = "SLA_MY_CONNECTIONS";
        return columnsData;
    };


    window.MyConnectionsListTableViewController = MyConnectionsListTableViewController;

    return MyConnectionsListTableViewController;

});
